<template>
  <section
    class="md:mt-8 m-auto bg-black pt-6 px-2 md:px-10 pb-10 shadow-black shadow-xl max-w-[1400px]"
  >
    <div
      class="w-full text-white font-electro flex flex-col text-center items-center pt-12 md:pt-8 pb-8 gap-6"
    >
      <h1 class="font-russo text-[#FF0000] text-[28px] md:text-[40px] uppercase">
        You're Using an Older Version of Rally Navigator
      </h1>

      <p class="text-[18px] md:text-[22px] max-w-[820px]">
        This page used to manage your subscription, but it has moved. Newer
        versions of Rally Navigator handle everything &#8212; your subscription,
        upgrades, and account &#8212; directly inside the app.
      </p>

      <p class="text-[18px] md:text-[22px] max-w-[820px]">
        To manage your subscription, simply download and install the latest
        version of Rally Navigator. Once you open it, you'll find your
        subscription and account options built right in.
      </p>

      <RallyLogoDownload link-text="Download the Latest Rally Navigator" />

      <div
        class="font-arial text-[16px] md:text-[18px] text-[#F3EEEE] max-w-[820px] flex flex-col gap-4 text-left mt-4"
      >
        <h2 class="font-russo text-[#FF0000] text-[22px] text-center uppercase">
          How to Manage Your Subscription
        </h2>
        <ol class="flex flex-col gap-3 list-decimal list-inside">
          <li>
            <router-link
              to="/download"
              class="text-[#FF0000] hover:underline decoration-[#FF0000]"
            >
              Download the latest version of Rally Navigator
            </router-link>
            for Windows, macOS, or Linux.
          </li>
          <li>Install the update and open the app.</li>
          <li>
            Open the app menu and choose <strong>My Subscription</strong> to
            link, manage, or upgrade your subscription.
          </li>
        </ol>
        <p class="text-center mt-2">
          Need a hand? Reach us at
          <a
            href="mailto:info@rallynavigator.com"
            class="text-[#FF0000] hover:underline decoration-[#FF0000]"
            >info@rallynavigator.com</a
          >.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import RallyLogoDownload from './RallyLogoDownload.vue';

export default {
  name: 'ManageSubscription',
  components: {
    RallyLogoDownload,
  },
};
</script>

<style scoped></style>
